// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import IssuuLookupListResultModel from '../../model/issuu-lookup-list-result-model';
import IssuuLookupListResultDTO from '../dto/issuu-lookup-list-result-dto';
import dtoSchema from '../schemas/issuu-lookup-list-result-schema';
import IssuuLookupModel from '../../model/issuu-lookup-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class IssuuLookupListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<IssuuLookupListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => IssuuLookupModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: IssuuLookupModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<IssuuLookupListResultDTO>): IssuuLookupListResultModel;
  static toModel(dto: DeepPartial<IssuuLookupListResultDTO> | undefined | null): IssuuLookupListResultModel | undefined;
  static toModel(dto: DeepPartial<IssuuLookupListResultDTO> | undefined | null): IssuuLookupListResultModel | undefined {
    return dto ? new IssuuLookupListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<IssuuLookupListResultModel> | IssuuLookupListResultModel): IssuuLookupListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as IssuuLookupListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for IssuuLookupListResultModel, can not map to IssuuLookupListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
